export default __webpack_public_path__ + "static/2118-8c8c94517637caee81c7537000f4c5b5.gif";